import { EmptyText } from './empty-text.tsx';

type Props = {
    children: string | undefined | null;
};

export function TextOrEmpty({ children }: Props) {
    if (!children) {
        return <EmptyText />;
    }

    return <>{children}</>;
}
